import React from 'react'
import './styles.css'
import _ from 'lodash'
import PopupPlan from '~/components/PopupPlan'
import Spinner from '~/components/Spinner'
import { getSubscriptionPlans, getInvisiblePlans } from '~/redux/user/subscription'
import popup from '~/views/Popup/popup'
import connect from "~/tools/connect";
import userStore from '~/redux/user/store';

class SelectPlans extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      plans: [],
      selected: null,
      loading: true
    }
  }

  componentDidMount() {
    if (this.state.user && this.state.user.isSubscribed) {
      window.location.href = '/'
      return false
    }
    if (!window.sessionStorage.getItem('plans')) {
      getSubscriptionPlans().then(plans => {
        this.setState({ 'plans': plans, loading: false })
      })
    } else {
      getInvisiblePlans().then(plans => {
        this.setState({ 'plans': plans, loading: false })
      })
    }
  }

  selectPlan(i, id) {
    if (i === this.state.selected)
      return popup.createSubscription(id)
    this.setState({...this.state, selected: i })
  }

  render() {
    const image = _.get(this.props.layout, 'settings.images.desktop')
    return (
      <div className="select-plans-container" style={{ backgroundImage: `url(${image})` }}>
        { this.state.user && this.state.user.isSubscribed ? (
          <div className="thank-you"> Thank you for subscribing! </div>
        ) : (
          <div className="select-plans">
            <div className="header">
              <p>{this.props.data.title}</p>
              <p className="header-copy">{this.props.data.description}</p>
            </div>
            { this.state.loading && <Spinner/> }
            <div className="plans-container site-color">
              {
                this.state.plans.map( (data, i) => {
                  return (
                    <PopupPlan
                      plan={ data }
                      key={ data.id }
                      onClick={ _ => this.selectPlan(i, data.id) }
                      selected={ i === this.state.selected } />
                  )
                })
              }

            </div>
             <p className="choose-plan-text">Choose your plan</p>
          </div>
          ) }
      </div>
    )
  }
}
connect(SelectPlans, (state) => ({ user: state.user }), userStore)

export default SelectPlans
